import { getInitials } from '@/lib/initials'

export type AvatarSize = 'sm' | 'md'

export interface AvatarProps {
  name: string | null | undefined
  size?: AvatarSize
  className?: string
}

const SIZE_CLASSES: Record<AvatarSize, string> = {
  sm: 'h-8 w-8 text-xs',
  md: 'h-10 w-10 text-sm',
}

export function Avatar({ name, size = 'sm', className = '' }: AvatarProps): JSX.Element {
  const initials = getInitials(name)
  return (
    <span
      className={`inline-flex items-center justify-center rounded-full bg-neon-cyan/20 font-semibold text-neon-cyan ${SIZE_CLASSES[size]} ${className}`.trim()}
      data-testid="avatar"
    >
      <span aria-hidden="true">{initials}</span>
    </span>
  )
}
